document.addEventListener('DOMContentLoaded', function() {
  var menuItems = document.querySelectorAll('.custom-parent');
  var noChildItems = document.querySelectorAll('li a.nochild'); // Select all .nochild links
  var toggleButtons = document.querySelectorAll('.down');

  // Existing functionality for .custom-parent items
  menuItems.forEach(function(parentItem) {
    var subMenu = parentItem.closest('li').querySelector('.submenu');
    
    // Check if parent link matches the current URL
    if (parentItem.href === window.location.href) {
      parentItem.classList.add('active');
      if (subMenu && subMenu.classList.contains('submenu')) {
        subMenu.classList.add('active');
      }
    }

    // Check submenu links for active state
    if (subMenu) {
      var submenuLinks = subMenu.querySelectorAll('a');
      submenuLinks.forEach(function(submenuLink) {
        if (submenuLink.href === window.location.href) {
          submenuLink.classList.add('active');
          subMenu.classList.add('active');
          parentItem.classList.add('active');
        }
      });
    }
  });

  // New functionality for .nochild items
  noChildItems.forEach(function(noChildItem) {
    if (noChildItem.href === window.location.href) {
      noChildItem.classList.add('active', 'nochild-active'); // Add both 'active' and 'nochild-active' classes
      console.log('Added active class to nochild:', noChildItem); // Debugging
    }
  });

  // Toggle functionality for submenus
  toggleButtons.forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();

      var parentItem = toggle.previousElementSibling;
      var subMenu = toggle.nextElementSibling;

      // Close all other open submenus
      menuItems.forEach(function(item) {
        var itemSubMenu = item.closest('li').querySelector('.submenu');
        if (itemSubMenu && itemSubMenu.classList.contains('submenu')) {
          if (itemSubMenu !== subMenu) {
            itemSubMenu.classList.remove('active');
            item.classList.remove('active');
          }
        }
      });

      // Toggle the clicked submenu
      if (subMenu && subMenu.classList.contains('submenu')) {
        if (subMenu.classList.contains('active')) {
          subMenu.classList.remove('active');
          parentItem.classList.remove('active');
        } else {
          subMenu.classList.add('active');
          parentItem.classList.add('active');
        }
      }
    });
  });
});
